import Decimal from "decimal.js";

import { Order, Package, PackageItem } from "@megaron/fulfillment-contracts";
import { OrderDisplayFulfillmentStatus } from "@megaron/shopify";

export const normalizeGtin = (s?: string | null) => (s ?? "").replace(/\D/g, "").replace(/^0+/, "");

export const hasPackageChanged = (prev: Package, next: Package): boolean => {
  if (prev.name !== next.name || prev.size !== next.size || prev.isLabelScanned !== next.isLabelScanned) {
    return true;
  }
  const prevItemsMap = new Map(prev.items.map((i) => [i.variantId, i.quantity]));
  const nextItemsMap = new Map(next.items.map((i) => [i.variantId, i.quantity]));
  if (prevItemsMap.size !== nextItemsMap.size) return true;
  for (const [variantId, quantity] of prevItemsMap) {
    if (nextItemsMap.get(variantId) !== quantity) return true;
  }
  for (const [variantId, quantity] of nextItemsMap) {
    if (prevItemsMap.get(variantId) !== quantity) return true;
  }
  return false;
};

export const getPackageWeight = (order: Order | undefined, pkg: Package): number => {
  const total = pkg.items.reduce((sum, item) => {
    const full = order?.items.find((i) => i.variantId === item.variantId);
    if (!full) return sum;
    return sum.plus(new Decimal(full.weight ?? 0).mul(item.quantity));
  }, new Decimal(0));
  return Number(total.toFixed(1));
};

export const addItemToPackage = (pkg: Package, item: PackageItem): Package => {
  const existing = pkg.items.find((x) => x.variantId === item.variantId);
  if (existing) {
    return {
      ...pkg,
      items: pkg.items.map((x) => (x.variantId === item.variantId ? { ...x, quantity: x.quantity + 1 } : x)),
    };
  }
  return {
    ...pkg,
    items: [
      ...pkg.items,
      {
        lineItemId: item.lineItemId,
        name: item.name,
        variantId: item.variantId,
        productId: item.productId,
        quantity: 1,
        weight: item.weight,
        barcode: item.barcode,
        price: item.price,
        engraving: item.engraving,
        purchaseId: item.purchaseId,
      },
    ],
  };
};

export const isAddPackageDisabled = (order: Order): boolean =>
  order.fulfillmentStatus === OrderDisplayFulfillmentStatus.OnHold ||
  order.fulfillmentStatus === OrderDisplayFulfillmentStatus.Fulfilled ||
  order.deliveryMethod === "palletDelivery";
